<template>
    <div class="wrapper" @click="global_clicked">                    
        <div class="content">
            <div class="element-wrapper">
                <div class="element-title">
                        <h3>Aadhaar Number</h3>
                        <i class="icon"></i>                
                        <p class="title-text" v-show="verified != 1">
                            Click "Check" button to verify
                        </p>
                    </div>
                <div class="element-content">
                    <input type="tel" 
                        @input="id_no_phone_textInput($event)" 
                        @focus="idno_phone_bootomFocus" 
                        v-model="aadhaar" 
                        @blur="idno_phone_blur" placeholder="Enter the Aadhaar Number"
                        :readonly="verified == 1"
                    >                    
                    <div class="check-btn"  @click="getLastPhone" v-show="verified != 1">Check</div>
                    <div class="checked-btn" v-show="verified == 1">Verified</div>
                </div>
            </div>
            <div class="element-container" v-for="(item, ind) in obj.select_types" :key="ind">
                <template v-if="item.dataType=='0'">
                    <Dropdonw
                        :title="item.key"
                        :required="item.checkReq"
                        :choices="item.dictionaryVoList"
                        :keys="item.value"    
                        :is_show="item.is_show" 
                        :is_error="item.is_error"
                        :label="item.label"              
                        :component_id = "ind"                    
                        fromPage = "kyc_szy_idno_phone_page"
                        :requestId = "requestId"
                        @modify="modify_dropdown"
                        @modifyError="modify_error"
                        @setValue="setValue"
                    >
                    </Dropdonw>        
                </template>
                
                <template  v-if="item.dataType=='1' && !item.readonly">
                    <MyInput
                        :title="item.key"
                        :component_id = ind
                        :required="item.checkReq"
                        :keys="item.value"
                        :label="item.label"
                        :is_show="item.is_show"
                        :is_error="item.is_error"
                        :checkType="item.checkType"
                        :maxlength="item.lengthLimitMax"
                        fromPage = "kyc_szy_idno_phone_page"
                        :eventCount = item.eventCount
                        :requestId = "requestId"                        
                        @setCount="setCount"
                        @modifyError="modify_error"
                        @setValue="setValue"
                        @refreshRequestId="refreshRequestId"
                    >
                    </MyInput>
                </template>
                <template  v-if="item.dataType=='1' && item.readonly">
                    <MyReadOnlyInput
                        :title="item.key"
                        :component_id = ind
                        :required="item.checkReq"
                        :keys="item.value"
                        :label="item.label"
                        :is_show="item.is_show"
                        :is_error="item.is_error"
                        :checkType="item.checkType"
                        :maxlength="item.lengthLimitMax"
                        fromPage = "kyc_szy_idno_phone_page"
                        :value="obj.params[item.value]['value']"
                        :readonly="item.readonly"
                        :eventCount = item.eventCount
                        :requestId = "requestId"                        
                        @setCount="setCount"
                        @modifyError="modify_error"
                        @setValue="setValue"
                        @refreshRequestId="refreshRequestId"
                    >
                    </MyReadOnlyInput>
                </template>
                <template v-if="item.dataType == '2'">
                    <div>
                        <MyDatePicker
                        :title="item.key"
                        :component_id = ind
                        :required="item.checkReq"
                        :keys="item.value"
                        :label="item.label"
                        :is_show="item.is_show"
                        :is_error="item.is_error"
                        :checkType="item.checkType"
                        :maxlength="item.lengthLimitMax"
                        fromPage = "kyc_szy_idno_phone_page"
                        :eventCount = item.eventCount
                        :requestId = "requestId"
                        :value = "obj['params'][item.value].value"
                        @setCount="setCount"
                        @modifyError="modify_error"
                        @modify="modify_dropdown"
                        @setValue="setValue"
                        @refreshRequestId="refreshRequestId"
                        ></MyDatePicker>
                    </div>
                </template>
                <template  v-if="item.dataType=='4'">
                    <State
                        :title="item.key"
                        :required="item.checkReq"
                        :component_id = ind
                        :keys="item.value"
                        :is_error="item.is_error"
                        :is_show="item.is_show"
                        :label="item.label"
                        @setValue="setValue"
                        @modify="modify_normal"
                        @modifyError="modify_error"
                    >
                    </State>
                </template>
                <template  v-if="item.dataType=='5'">
                    <Location
                        :title="item.key"
                        :required="item.checkReq"
                        :component_id = ind
                        :keys="item.value"   
                        :label="item.label"   
                        :is_error="item.is_error"                  
                        :is_show="item.is_show"
                        :state_id = "state_id"
                        @setValue="setValue"
                        @modify="modify_normal" 
                        @modifyError="modify_error"                   
                    >
                    </Location>
                </template>
                
            </div>            
        </div>       
        <div class="placeholder"></div>
        <div class="btn-container">            
            <a class='btn-submit' :class='{"unactive":!btnStatus}' @click="submit">CONFIRM TO NEXT</a>
        </div>
        <div class="dialog-wrap" v-show="verify_dialog_show">
            <div class="dialog-content">
                <i class="icon icon-close" @click="closeVerifyDialog"></i>                
                <div class="verify-phone">
                    <div class="caption">
                        Please enter the first 7 digits of the phone number
                    </div>
                    <div class="pass-input">
                        <div class="prefix">
                            <div class="prefix-element">+</div>
                            <div class="prefix-element">9</div>
                            <div class="prefix-element">1</div>
                        </div>
                        <div class="op-list">
                            <div class="op-element" v-for="(item,ind) in phones"  :key=ind>
                                <div class="input-op-container">
                                    <input ref='inputRefs' type="tel" v-model="phones[ind]" @input="codeInput($event, ind)" @focus="inputFocus($event, ind)" @keyup.delete="keydownDelete">
                                </div>
                            </div>                
                        </div>
                        <div class="afterfix" >
                            <div class="afterfix-element" v-for="(element,ind) in `${last3Phone}`" v-text="element" :key="ind"></div>                            
                        </div>
                    </div>
                    <div class="btn-v-container" v-show="verifyStep == 1">
                        <a href="javascript:void(0);"  class="btn-verify" @click="verifyPhone">Verify</a>
                    </div>
                </div>
                <div class="verify-code"  v-show="verifyStep == 2">
                    <div class="caption">
                        Please enter the 6 digits of OTP
                    </div>
                    <div class="input-container">                            
                        <div class="input-content-container">
                            <input type="tel" v-model="verify_code" placeholder="Enter the verification code" @input="verificationCodeInput">
                        </div>
                        <button class="get_code" @click="verifyPhone">{{ code_text }}</button>
                    </div>
                    <div class="btn-v-container">
                        <a href="javascript:void(0);"  class="btn-verify" @click="verifyCode">Verify</a>
                    </div>
                </div>
                
            </div>
        </div>  
        <div class="dialog-wrapper" v-show="another_verification">
            <div class="dialog-code change">
                <div class="dialog-header">
                    Can not finish the verification?
                </div>
                <div class="dialog-content">
                    <p class="dialog-caption">
                        Change another way to finish the verification
                    </p>                    
                    <div class="dialog-btn-container">
                        <a class='submit-code' href="javascript:void(0);" @click="changeVerify" >Change</a>
                    </div>
                </div>
            </div>
        </div>       
    </div>
</template>
<style lang="less" scoped>
@import "~assets/less/icon.less";
.dialog-wrapper{
    position:fixed;
    width: 100%;
    height: 100%;
    left:0;
    top:0;
    right:0;
    bottom:0;
    background:rgba(0,0,0,0.6);    
    .dialog-code{
        width:600px;
        height:550px;
        margin:0 auto;
        position:absolute;
        left:50%;
        top:50%;
        transform: translate(-50%,-50%);
        background:#fff;
        padding:40px;
        border-radius: 20px;
        .dialog-caption{
            font-size: 28px;
            color:#00BE82;
            margin-top: 50px;
        }
        .dialog-btn-container{
            width: 450px;
            margin:100px auto 0 auto;
            .submit-code{
                display:block;
                width: 450px;
                height: 100px;
                line-height: 100px;
                text-align: center;
                font-size: 36px;                
                border-radius: 10px;
                background:#00BE82;
                color:#fff;
            }
        }
        &.change{
            height:auto
        }
        .dialog-header{
            margin:20px 0;
            text-align: center;
            color:#00BE82;
            font-size: 40px;
        }
    }
}
.input-container{
            padding:30px 0 30px 0;
            display:flex;
            justify-content: flex-start;
            align-items: center;
            border-bottom:2px solid #666;   
            height: 50px;         
            .prefix{
                display:block;
                color:#00BE82;
                font-size: 32px;
                height:50px;      
                line-height: 50px;      
                border-right:1px solid #999;
                padding:0 20px 0 0;
                margin-right: 20px;                
            }
            .get_code{
                display: block;
                width: 168px;
                height: 72px;
                background: #fff;
                border-radius: 36px;
                border:2px solid #00BE82;
                text-align: center;
                line-height: 72px;
                padding: 0;
                margin: 0;
                color:#00BE82;
                font-size: 28px;
            }
            .input-content-container{
                flex:1;
                // margin-left: 20px;
                input{
                    display:block;
                    width: 100%;
                    height: 100%;
                    border:none;
                    font-size: 32px;
                    background:transparent;
                    color:#333;
                    &::placeholder{
                        color:#00BE82;
                    }
                }
            }
        }
.op-list{
    display: flex;
    justify-content: center;
    .op-element{                    
        margin-right: 10px;
        &.active{
            .input-container{
                border-color:#00BE82;
            }  
        }        
        .input-op-container{
            width: 45px;
            height: 45px;            
            border-bottom:2px solid #000;                        
            input{
                display:block;
                width: 100%;
                height: 100%;
                color:#00BE82;
                border:none;
                font-size: 38px;
                margin:0 auto;
                text-align: center;
                background: transparent;
                padding:0
            }
        }
    }
    }
.dialog-wrap{
    position:fixed;
    width: 100%;
    height: 100%;
    top:0;
    bottom:0;
    left:0;
    right:0;
    background:rgba(0,0,0,0.5);
    .dialog-content{
        position:absolute;
        top:50%;
        left:50%;
        transform: translate(-50%,-50%);
        background:#fff;
        padding:30px;
        width: 620px;
        margin:0 auto;
        border-radius: 30px;
        .icon-close{
            position:absolute;
            right:30px;
            top:10px;
        }
        .caption{
            font-size: 26px;
            color:#333;
            line-height:1.5;
            padding:25px 0;
        }
        .btn-v-container{
            // margin-top: 50px;
            margin:50px auto;
            width: 320px;
            .btn-verify{
                display: block;
                text-align: center;
                height: 65px;
                width: 320px;
                border-radius: 65px;
                font-size: 36px;
                line-height: 65px;
                background:#00BE82;
                color:#fff;
            }
        }
        .verify-code{
            margin-top: 30px;
        }
        .pass-input{
            display: flex;
            justify-content: center;
            align-items: center;
            .prefix{                
                display: flex;
                justify-content: start; 
                align-items: center; 
                .prefix-element{
                    margin-right: 10px;
                    font-size: 32px;
                    color:#00BE82;
                    border-bottom: 2px solid transparent;
                }
            }
            .afterfix{
                font-size: 32px; 
                display: flex;
                justify-content: start;   
                align-items: center;            
                .afterfix-element{
                    font-size: 32px;
                    color:#00BE82;
                    margin-right: 15px;
                    border-bottom: 2px solid transparent;
                }
            }
            .input{
                width: 400px;
            }
        }
        

    }
}
    div.element-wrapper {
        padding:20px 0;
        border-bottom: 2px solid #EFEEF1;
        div.element-title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 15px;
            h3 {
                color:#73698F;
                font-size: 26px;  
                overflow: hidden;
                padding:15px 0;      
            }
            
            p.title-text {
                font-size: 24px;
                color:#00BE82;
            }
        }

        div.element-content {
            height:40px;
            line-height: 40px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            input{
                display:block;
                width: 550px;
                font-size: 32px;
                border:none;
                &::placeholder{
                    color:#D0CDDA;
                }
            }
            div.checked-btn{
                width: 120px;
                height:60px;
                line-height: 60px;
                text-align: center;
                font-size: 24px;
                background:#00BF02;
                border-radius: 40px;
                color:#fff;
            }
            div.check-btn {
                width: 120px;
                height:60px;
                line-height: 60px;
                text-align: center;
                font-size: 24px;
                background:#00BE82;
                border-radius: 40px;
                color:#fff;
            }
        }
    }
    .wrapper{
        padding:20px 40px;
        .guide{
            color:#A59BB3;
            font-size: 30px;
            em{
                color:#00BE82;
                font-weight: 700;
            }
        }
        .title{
            color:#1F201E;
            font-weight: 700;
            font-size: 40px;
            margin: 0 0 50px 0;  
        }
    }
    .btn-container{
        position: fixed;
        left:0;
        bottom: 0;        
        background:#fff;
        padding:40px;
        // padding:40px;
        .btn-submit{
            display: block;
            width: 670px;
            height: 96px;
            line-height: 96px;
            text-align: center;
            border-radius: 12px;
            background:#00BE82;
            font-size: 32px;
            margin:0 auto;
            color:#fff;
            &.unactive{
                background:#f0f0f0;
                color:#999
            }
        }
    }
    .placeholder{
        height: 176px;        
    }
</style>
<script>

import { reactive, onMounted, computed, ref , getCurrentInstance, onBeforeMount, onBeforeUnmount} from 'vue'
import {  manual_phone_submit, identityConfig6,getLastPhoneByAadhaar,aadhaarMobileVerify,smsOtpVerify  } from '@api/index'
import Dropdonw from '@/components/business/kyc/dropdown.vue'
import MyInput from '@/components/business/kyc/input.vue'
import MyReadOnlyInput from '@/components/business/kyc/readonly.vue'
import State from '@/components/business/kyc/state.vue'
import Location from '@/components/business/kyc/location.vue'
import MyDatePicker from '@/components/business/kyc/mydatepicker.vue'
import { useRouter } from 'vue-router'
import { useLoading } from 'vue-loading-overlay'
import { v4 as uuidv4} from 'uuid'
import { useStore } from 'vuex'

export default {
    props: ['data'],
    components:{
        Dropdonw,
        MyInput,
        State,
        Location,
        MyDatePicker,
        MyReadOnlyInput
    },    
    setup (props, ctx) {
        const router = useRouter()
        const route = router.currentRoute
        const clicked = ref(false)
        const btnStatus = ref(false)
        const proxy  = getCurrentInstance().proxy
        const store = useStore()
        const idNo = ref("")        
        const phones = ref(['','','','','','',''])   
        const last3Phone = ref("")     
        const aadhaar = ref("")
        const idNo_event_count = ref(0)
        const code_text = ref("OTP")
        const verify_code = ref("")
        let seconds = ref(60)
        const verified = ref(0)
        const another_verification = ref(false)
        const idNo_event_requestId = ref(uuidv4())
        const to = ref(0)
        const inputRefs = ref([]);
        let obj = reactive({
            select_types:[],
            input_types:[],
            state_types:[],
            district_types:[],            
            params:{                
                "birthDate":[],
                "idNo":""
            }
        })
        const verifyStep = ref(1)   
        const verify_dialog_show = ref(false)
        const index = ref(0)  
        const codeInput = (e, ind) => { 
            let v = e.target.value           
            if(/\D+/.test(v)) {
                phones.value[ind] = ''
            } else {                
                if (v.length > 0) {
                    phones.value[ind] = e.data
                } else {
                    phones.value[ind] = v[0]
                }
                // alert(index.value, v)
                if(index.value < 6 & v!= '') {
                    try {
                        inputRefs.value[`${index.value}`].blur()
                        index.value += 1
                        inputRefs.value[`${index.value}`].focus()    
                    } catch (error) {
                        alert(error)
                    }                    
                }
            }            
        }
        const verificationCodeInput = (e) => {
            let v = e.target.value
            if(/\D+/.test(v)) {
                verify_code.value = verify_code.value.substring(0, verify_code.value.length - 1)
            } 
            if(v.length > 6) {
                verify_code.value = verify_code.value.substring(0, verify_code.value.length - 1)
            } 

        }
        const requestId = ref(uuidv4())
        const state_id = computed(()=>{
            return obj.params['liveState'].value
        })
        const validate = () => {
            let res = true
            for(let x in obj.params){
                if (obj.params[x].value == '') {
                    obj.select_types[obj.params[x].ind].is_error = false
                    res = false
                }
            }
            if (res && verified.value != 1) {
                res = false
            }
            btnStatus.value = res
            return res
        }
        const $loading = useLoading()
        const globalClick = () => {           
            for (let x in obj.select_types){                
                if(obj.select_types[x].is_show && obj.select_types[x]['dataType'] == '0'){
                    uploadBury('complete', obj.params[obj.select_types[x]['value']].value, 1, x)
                    requestId.value = uuidv4()
                }
                obj.select_types[x].is_show = false
            }
        }
        onBeforeMount(()=>{
            store.dispatch('bury', {eventId:"kyc_szy_idno_phone_page_page_view"})
            store.dispatch("clearBuryCache", [])
        })
        onBeforeUnmount(()=>{
            store.dispatch('bury', {eventId:"kyc_szy_idno_phone_page_exit_page_tech"})
            store.dispatch("clearBuryCache", [])
        })
        const uploadBury = (type, value, numberTimes,x ) => {
            try {
                store.dispatch('buryCache', { 'event_id':  obj.select_types[x]['event_target'][type], value:value, requestId:requestId, numberTimes:numberTimes})           
            } catch (error) {
                console.log(error)    
            }
        }
        const submit = () => {            
            if(validate() && !clicked.value){
                clicked.value = true
                let loader = $loading.show({
                    container:null
                })
                let newParams = {}                
                for(let i in obj.params) {
                    newParams[i] = obj.params[i].value
                }
                newParams['idNo'] = aadhaar.value || ""
                store.dispatch("bury",{"event_id":"kyc_szy_idno_phone_page_enter_button_click"})
                manual_phone_submit(newParams).then((res)=>{
                    if(res.code == 0) {
                        store.dispatch("bury",{"event_id":"kyc_szy_idno_phone_page_enter_button_click_success"})
                        store.dispatch("uploadBury")
                        router.replace({
                            "path":"/auth/index",
                            "query":{
                                "pid":route.value.query.pid
                            }
                        })
                    } else {
                        let error_text = ""
                        for(let i = 0 ; i<res.data.errorColumn.length;i++) {
                            error_text += `${i+1}.  ${res.data.errorColumn[i].msg} \n`
                        }
                        proxy.$toast.show(error_text)
                        store.dispatch("bury",{"event_id":"kyc_szy_idno_phone_page_enter_button_click_success","msg":error_text})
                    }
                    loader.hide()
                    clicked.value = false
                }).catch(()=>{
                    clicked.value = false
                })
            }
        }
        onMounted(async () => {
            document.body.style.background = "#fff";
            const loader = proxy.$loading.show({
                container:null
            })
            let data = await identityConfig6()
            
            const finalArr = data.data.szyKycPage[0].inputVos.concat(data.data.szyKycPage[1].inputVos)
            
            // let ada = await getAadhaar()
            // idNo.value = ada.data.aadhaar || ""
            if(data.data.aadhaarCheckDTO.szyAadhaarPhoneVerifyFinish == 1) {
                    aadhaar.value = data.data.aadhaarCheckDTO.idNo
                    verified.value = 1
                    validate()
            }

            loader.hide()
            
            let select_type = finalArr.map((ele, ind)=>{
                ele.is_show = false
                ele.is_error = false
                
                
                if(ele.dataType == '0'|ele.dataType == '4'|ele.dataType == '5') {
                    ele.label = ele.label?ele.label:"Please select"
                } else if (ele.dataType == '1') {
                    ele.label = ele.label?ele.label:"Please input"
                } 
                if(ele.checkReq == 0) {
                    obj.params[ele.value] = {
                        "value":'',
                        "ind": ind,
                        "required":true
                    }
                    
                } else {
                    obj.params[ele.value] = {
                        "value":'',
                        "ind": ind,
                        "required":0
                    }
                }
                ele.event_target = store.state.buryConfig['kyc_szy_idno_phone_page'][ele.value] || ""
                if(ele.dataType == '1') {
                    ele.eventCount = 0
                }           
                return ele
            })
            // .filter(element => {
            //     return element.dataType == '0'            
            // })
            obj.select_types = select_type.map((ele, ind)=>{
                ele.is_show = false                
                ele.is_error = false
                obj.params[ele.value] = {
                    "value":'',
                    "ind": ind
                }
                ele.readonly = false
                if(ele.value == 'idNo') {
                    if(idNo.value.length > 0) {
                        ele.readonly = true
                        obj.params['idNo']['value'] = idNo.value
                    }
                }
                
                return ele
            })                        
        })
        const modify_normal = (k, v) => {
            for (let x in obj.select_types){                
                obj.select_types[x].is_show = false
            }
            obj.select_types[k]['is_show'] = v           
        }
        const modify_dropdown = (k, v, dictValue,uid,event_id) => {            
            setTimeout(()=>{
                obj.select_types[k]['is_show'] = v 
                if(v){
                    store.dispatch('buryCache', { 
                        'event_id':  event_id, 
                        'value': dictValue, 
                        requestId:uid,
                        numberTimes:0
                    })
                } else {
                    store.dispatch('buryCache', { 
                        'event_id':  event_id, 
                        value:dictValue, 
                        requestId:uid, 
                        numberTimes:1
                    })
                    refreshRequestId()   
                }  
            })
                  
                           
        }
        const setCount = (ind, count) => {
            obj.select_types[ind].eventCount = count
        }
        const refreshRequestId = () => {
            requestId.value = uuidv4()
        }                
        const modify_error = (k,v) =>{
            v = false
            obj.select_types[k]['is_error'] = v
        }
        const setValue = (k, v) => {       
            console.log("set")        
            obj.params[k].value = v
            validate()
        }    
        const inputFocus =  (e,ind) => {
            index.value = ind                        
        }    
        const keydownDelete  = (e) => {
            e.preventDefault();
                       
            // if(e.target.value == '') {
            if(index.value >= 1) {
                index.value -= 1                
                inputRefs.value[`${index.value}`].focus()    
            }                            
        }
        const getLastPhone = async () => {
            console.log(aadhaar.value);
            if(aadhaar.value.length  < 12) {
                proxy.$toast.show("Please enter correct Aadhaar Number")
                return 
            }            
            let loader = $loading.show({
                container:null
            })
            let data = await getLastPhoneByAadhaar({
                aadhaar:aadhaar.value
            })
            if(data.code == '0') {
                verify_dialog_show.value = true
                last3Phone.value = data.data.lastPhone
            } else if (data.code == '-1100001') {
                verify_dialog_show.value = false
                another_verification.value = true  
                shouldGoState.value = 2
            }  else if (data.code == '-1100003') {
                verify_dialog_show.value = false
                another_verification.value = true  
                shouldGoState.value = 3
            }  else {
                proxy.$toast.show(data.msg)
            }
            loader.hide()
        }
        // verify phone and aadhaar
        const verifyPhone = async () => {
            let pp = phones.value.join("")
            if(pp.length < 7) {
                proxy.$toast.show("Please enter correct phone number")
                return 
            }
            let loader = $loading.show({
                    container:null
            })
            let data = await aadhaarMobileVerify({
                "aadhaar": aadhaar.value,
                "phone":  phones.value.join("") +last3Phone.value
            })
            loader.hide()
            if(data.code == '0') {
                if(data.data.smsOtpVerify) {
                    verifyStep.value = 2
                    to.value = setInterval(()=>{                    
                        code_text.value = `${--seconds.value}s`
                        if(seconds.value<=0){
                            clearInterval(to.value)
                            code_text.value = 'resend'                            
                        }
                    },1000)
                } else if (data.code == '-1100001') {
                    verify_dialog_show.value = false
                    another_verification.value = true  
                    shouldGoState.value = 2
                }  else if (data.code == '-1100003') {
                    verify_dialog_show.value = false
                    another_verification.value = true  
                    shouldGoState.value = 3
                } else {
                    verify_dialog_show.value = false
                    verified.value = 1
                    validate()
                }
                
            } else {
                proxy.$toast.show(data.msg)
            }
        }
        // verify sms code  
        const verifyCode = async () => {
            if(verify_code.value.length < 6) {
                proxy.$toast.show("Please enter correct otp")
                return
            }
            let loader = $loading.show({
                    container:null
                })
            let data = await smsOtpVerify({
                "otp":verify_code.value
            })
            loader.hide()
            if(data.code == '0') {
                verify_dialog_show.value = false
                verified.value = 1
                validate()
            } else {
                proxy.$toast.show(data.msg)
            }

        }
        const closeVerifyDialog = () => {
            phones.value = ['','','','','','','']
            verify_code.value = ""
            verifyStep.value = 1
            verify_dialog_show.value = false
            clearInterval(to.value)
            to.value = 0
        }
        const shouldGoState = ref(0)
        const changeVerify = () => {
            ctx.emit("changeState", shouldGoState.value)
        }

        const id_no_phone_textInput = () => {            
            idNo_event_count.value = idNo_event_count.value + 1
        }
        const idno_phone_bootomFocus = (e) => {
            e.target.scrollIntoView({ block: "center" })
            try{
                store.dispatch('buryCache', { 
                    'event_id':  store.state.buryConfig["kyc_szy_idno_phone_page"]["idNo"]['focus'], 
                    value: e.target.value, 
                    requestId:idNo_event_requestId.value,
                    numberTimes: 0                   
                })            
            } catch(e) {
                console.log(e)
            }     
        }
        const idno_phone_blur = (e) => {  
            try{
                store.dispatch('buryCache', { 
                    'event_id':  store.state.buryConfig["kyc_szy_idno_phone_page"]["idNo"]['complete'], 
                    value: e.target.value, 
                    requestId:idNo_event_requestId.value,
                    numberTimes: idNo_event_count.value                  
                })
            } catch(e) {
                console.log(e)
            }      
            idNo_event_requestId.value = uuidv4()                                                
            idNo_event_count.value = 0             
        }

        return {
            obj,
            setValue ,
            requestId,
            modify_normal,
            state_id,
            submit,
            modify_error,
            btnStatus,
            route,
            globalClick,
            setCount,
            refreshRequestId,
            modify_dropdown,
            idNo,
            phones,
            codeInput,
            inputFocus,
            keydownDelete,
            
            last3Phone,
            getLastPhone,
            verify_dialog_show,
            aadhaar,
            verifyPhone,
            verifyStep,
            code_text,
            verify_code,
            verifyCode,
            closeVerifyDialog,
            verificationCodeInput,
            verified   ,
            changeVerify,
            another_verification,
            idno_phone_blur,idno_phone_bootomFocus,id_no_phone_textInput,
            inputRefs
        }
    }
}
</script>